const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const HCP = `//hcp${spell}.xinli001.com/`,
  APIS = {
    daturaUploadOpus: `${HCP}daturaCeping/uploadOpus`, //  上传图片并与accountId绑定关系
    daturaCommitAnswers: `${HCP}daturaCeping/commitAnswers`, //  提交测评
    daturaReport: `${HCP}daturaCeping/viewReport`, //  查询报告页
  }

export default APIS




// WEBPACK FOOTER //
// ./src/apis/datura.js